module.exports = __webpack_public_path__ + "static/media/github-10-512.39a6a554.png";